<template>
  <div class="root-wrap">
    <div class="subject-txt">{{ subjectName }}</div>
 <div class="difficulty-group">
  <button
    v-for="(item, index) in levels"
    :key="index"
    class="diff-btn"
    :class="['lv-' + index, { active: curIndex === index }]"
    @click="jumpTo(index)"
  >
    {{ item.text }} 
  </button>
</div>
   
  </div>
</template>

<script>
export default {
  props: {
    subjectName:{
      type:String
    },
    subjectId:{
      type:Number
    },
    diffcult: {
      type: Number
    }
  },
  data() {
    return{
      form:{},
      itemWidth: 0,
      points:[],
      curIndex:0,
      levels: [
        { text: '智能推送',   sub: '0' },
      { text: '容易',   sub: '1' },
      { text: '较易',   sub: '2' },
      { text: '中等',   sub: '3' },
      { text: '较难',   sub: '4' },
      { text: '困难',   sub: '5' },
     
    ]
    }
  },
  computed: {
    thumbDistance(){
      if(!this.points||!this.points.length) return 0
      return this.points[this.curIndex].distance-18>0?((this.points[this.curIndex].distance-18)):0
    }
  },
  methods: {
      jumpTo(index) {
        console.log(index)
    this.curIndex = index
      this.form.subject_difficulty_offset = this.curIndex
      this.$emit('changeDiffculty', this.form)
  
  },
    pointDown(e){
      let lx = e.layerX
      let cIndex = 0
      for(let i = this.points.length-1;i>=0;i--){
        let distance = this.points[i].distance
        if(lx >= distance){
          if((lx - distance)>=(this.itemWidth/2-16)) cIndex = i+1
          else cIndex = i
          break;
        }
      }
      if(cIndex > this.points.length-1)curIndex = this.points.length
      else if(cIndex < 0) cIndex = 0
      if(this.curIndex == cIndex) return
      this.curIndex = cIndex
      this.form.diffcult = this.curIndex
      console.log(this.form)
      this.$emit('changeDiffculty', this.form)
    }
  },
  mounted () {
    this.form =  {
        subject_id: this.$props.subjectId,
        subject_difficulty_offset: this.$props.diffcult>=0?this.$props.diffcult:0
    }
    console.log('8888888888',this.form)
    this.curIndex =  this.form.subject_difficulty_offset
    
  }
}
</script>

<style lang="scss" scoped>
.root-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.difficulty-group {
  display: flex;
  gap:46rem;
}
.diff-btn {
  padding: 10rem;
  // height: 40px;
 border: none;
  border-radius: 10rem;
background: #FFF;
  cursor: pointer;
  font-size: 20rem;
  color: var(--light-666666, #666);
  text-align: center;
  line-height: 1.2;
}
 
/* 高亮 */
 .active {
  background: var(--btn-bg, #409eff);
  color: #fff !important;
  border-width: 3px;
}
.subject-txt {
  min-width: 120px;
  color: #333;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
}

.slide-track {
  width: 504px;
  height: 28px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 0px 32px;
  .slide-progress-primary {
    display: flex;
    width: calc(100% - 14px);
    height: 10px;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--Radius-MAX, 100px);
    background: var(--light-cccccc, #ccc);
  }
  .slide-progress-second-primary{
    display: flex;
    height: 10px;
    border-radius: 100px;
    background: #2196F3;
    position: absolute;
    left: 8px;
  }
  .slide-point-wrap{
    width: calc(100% - 14px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    z-index: 180;
    .slide-point{
        width: 16px;
        height: 16px;
        border-radius: 100px;
        background: #fff;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30);
    }
  }
  .slide-thumb{
    width: 24px;
    height: 24px;
    background: #fff;
    border-radius: 100px;
    border: 3px solid #2196F3;
    position: absolute;
    z-index: 90;
    left: 0px;
    box-shadow: 0px 2px 4px rgba(60, 124, 252, 0.60);
  }

}

.slide-progress-txt {
  color: var(--light-333333, #333);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

.img-star {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  margin-left: 8px;
}
</style>